//import loading from '../assets/images/loading-buffering.gif';

export const getSizedImageUrl = async (url: string, size: string): Promise<string> => {
  if (!url || !size) return '';

  try {
    const parts = url.split("/");
    const fileName = parts.pop();
    const basePath = parts.join("/");
    const sizedUrl = `${basePath}/${size}-${fileName}`;

    const exists = await checkImageExists(sizedUrl);
    return exists ? sizedUrl : '';
  } catch (e) {
    console.error("Error generating sized image URL:", e);
    return '';
  }
};

const checkImageExists = (url: string): Promise<boolean> =>
  new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
